module.exports = __webpack_public_path__ + "img/logo.96e989b9.png";